import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Box, Typography } from "@mui/material";
import { styledComponent } from "../utils/styled";
import { useTheme } from "../context/ThemeContext";

const STATUS_COPY = {
  DRAFT: {
    text: "DRAFT - Not visible to technicians",
    bg: { dark: "#434950", light: "#A8AEB6" },
    color: { dark: "#ECEFF3", light: "#31363B" },
  },
  ACTIVE: {
    text: "ACTIVE - Visible to technicians",
    bg: { dark: "#013020", light: "#D6EEE8" },
    color: { dark: "#ECEFF3", light: "#434950" },
  },
  INACTIVE: {
    text: "INACTIVE - Not visible to technicians",
    bg: { dark: "#212425", light: "#D1D3D6" },
    color: { dark: "#ECEFF3", light: "#434950" },
  },
};

const BannerStrip = styledComponent(Box)(({ status, visible, isDark }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1200,
  height: "24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: STATUS_COPY[status]?.bg[isDark ? "dark" : "light"],
  filter: "drop-shadow(0px 4px 2px rgba(0,0,0,0.1))",
  pointerEvents: "none",
  opacity: visible ? 1 : 0,
  transition: "opacity 300ms ease",
}));

const BannerText = styledComponent(Typography)(({ status, isDark }) => ({
  fontFamily: "Inter",
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "12px",
  letterSpacing: "0px",
  color: STATUS_COPY[status]?.color[isDark ? "dark" : "light"],
}));

// Portaled to document.body so it always paints above the Unity iframe and the
// chat/animation overlay panel's own portal (zIndex 1000).
export function DpmStatusBanner({ status, trigger }) {
  const [visible, setVisible] = useState(true);
  const { isDark } = useTheme();

  useEffect(() => {
    setVisible(true);
    const timer = setTimeout(() => setVisible(false), 4000);
    return () => clearTimeout(timer);
  }, [trigger]);

  if (!status || !STATUS_COPY[status]) return null;

  return createPortal(
    <BannerStrip status={status} visible={visible} isDark={isDark}>
      <BannerText status={status} isDark={isDark}>
        {STATUS_COPY[status].text}
      </BannerText>
    </BannerStrip>,
    document.body,
  );
}
